import React, { useState,useEffect, useMemo } from "react"; 

import { RichTextEditor } from '@mantine/rte';
import {decode} from 'html-entities';

const RteComponents = (props) =>{
    
    console.log('desc',props.description)
    const [descriptions, setDescriptions] = useState(null);

    useEffect( ()=>{
        if(props.description)
        {
            setDescriptions(decode(props.description))
        }

    },[props.description]

    )

        const seteditFunction = (text) =>{
            //console.log(text)
            props.setdescription(text)
        }


     
    return(
        <div>
            <label className="degreehead">Description</label>
            { descriptions ? <RichTextEditor onChange={ seteditFunction }  value={descriptions} />

            :null
            
            }
            
        </div>
    )
}

export default RteComponents;
